import { Plugins } from '@leverege/plugin';
import ValueVisibilizer from "./ValueVisibilizer.js";
import ValueVisibilizerEditor from "./ValueVisibilizerEditor.js";
import IfEmptyVisibilizer from "./IfEmptyVisibilizer.js";
import IfEmptyVisibilizerEditor from "./IfEmptyVisibilizerEditor.js";
export default {
  install: opts => {
    // IfEmpty Visibilizer
    Plugins.add('Model', {
      type: IfEmptyVisibilizer.TYPE,
      model: IfEmptyVisibilizer
    });
    Plugins.add('ModelEditor', {
      type: IfEmptyVisibilizer.TYPE,
      editor: IfEmptyVisibilizerEditor
    });
    Plugins.add('Visibilizer', {
      type: IfEmptyVisibilizer.TYPE,
      name: 'Show if Empty?',
      visibilizer: IfEmptyVisibilizer
    });

    // Visibilizer
    Plugins.add('Model', {
      type: ValueVisibilizer.TYPE,
      model: ValueVisibilizer
    });
    Plugins.add('ModelEditor', {
      type: ValueVisibilizer.TYPE,
      editor: ValueVisibilizerEditor
    });
    Plugins.add('Visibilizer', {
      type: ValueVisibilizer.TYPE,
      name: 'Static',
      visibilizer: ValueVisibilizer
    });
  }
};